/* THE GARAGE - storing builds, with a picture and a date.
   ==========================================================================
   builder-share.js keeps ONE build in localStorage so a visitor can pick up
   where they left off. The Garage is a collection: every build someone chose
   to keep, each with a snapshot of how it actually looked and when.

   WHY THERE IS A PICTURE
   A saved build is a string of option values. Shown as text it is a spec
   list; shown as the bike it is a thing you made. The snapshot is taken from
   the live 3D canvas at the moment of saving, so it is the exact bike on
   screen - not a stock photo of a different one.

   TWO BUGS THIS FILE HAS ALREADY HAD, both worth remembering:

   1. The save button carried class="pm-share pm-garage-save" to borrow
      builder-share.js's styling. builder-share guards its own mount with
      querySelector('.pm-share'), and this script runs first (head vs body) -
      so builder-share found THIS button, assumed its own existed, and never
      created "Copy build link". ar-view.js and share-card.js also anchor to
      '.pm-3d .pm-share', so they attached to the garage button too. One
      borrowed class, four broken features. It has its own class now.

   2. The snapshot went canvas -> dataURL -> new Image() -> draw. A data URL
      does NOT decode synchronously, so `img.width` was 0 on the very next
      line and every save silently stored no picture. Drawing the WebGL canvas
      straight onto a 2D canvas needs no decode step at all, which is both
      correct and simpler - see snapshot() below.
   ========================================================================== */
(function garageStore() {
  var KEY = 'pm-garage-v1';
  var MAX = 12;

  /* 480px wide at 0.72 quality lands around 40-60KB, so a full garage of 12
     sits comfortably inside the ~5MB localStorage budget. */
  var SHOT_W = 480;
  var SHOT_QUALITY = 0.72;

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var list = JSON.parse(raw);
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
      return true;
    } catch (e) {
      /* Almost always the quota, and almost always the pictures. Drop the
         oldest one and retry rather than losing the build itself. */
      try {
        for (var i = list.length - 1; i >= 0; i--) {
          if (list[i].shot) {
            delete list[i].shot;
            window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
            return true;
          }
        }
      } catch (e2) {}
      return false;
    }
  }

  /* ---- the snapshot ------------------------------------------------------
     Entirely synchronous. render -> drawImage(webglCanvas) -> toDataURL.
     A canvas is a valid drawImage source with no decoding involved, so the
     pixels are there immediately - unlike an Image built from a data URL,
     which was the bug.

     The render and the read must stay in the same block: WebGL clears the
     drawing buffer once the frame is composited, so a tick later it is
     blank. */
  function snapshot() {
    var s = window.__pmScene;
    if (!s || !s.renderer || !s.scene || !s.camera) return null;

    try {
      s.renderer.render(s.scene, s.camera);
      var gl = s.renderer.domElement;
      if (!gl.width || !gl.height) return null;

      /* Pass 1: copy at full size, transparent, so the bike's own pixels can
         be found. The stage canvas is mostly empty space around the model. */
      var full = document.createElement('canvas');
      full.width = gl.width;
      full.height = gl.height;
      var fctx = full.getContext('2d');
      fctx.drawImage(gl, 0, 0);

      var box = { x: 0, y: 0, w: gl.width, h: gl.height };
      try {
        var px = fctx.getImageData(0, 0, full.width, full.height).data;
        var minX = full.width, minY = full.height, maxX = -1, maxY = -1;
        for (var y = 0; y < full.height; y++) {
          for (var x = 0; x < full.width; x++) {
            if (px[(y * full.width + x) * 4 + 3] > 8) {
              if (x < minX) minX = x;
              if (x > maxX) maxX = x;
              if (y < minY) minY = y;
              if (y > maxY) maxY = y;
            }
          }
        }
        if (maxX > -1) {
          var pad = 12;
          box.x = Math.max(0, minX - pad);
          box.y = Math.max(0, minY - pad);
          box.w = Math.min(full.width - box.x, maxX - minX + 1 + pad * 2);
          box.h = Math.min(full.height - box.y, maxY - minY + 1 + pad * 2);
        }
      } catch (e) {
        /* no crop; the full frame is still a valid picture */
      }

      /* Pass 2: the cropped bike, scaled, on an opaque backdrop - JPEG has no
         alpha, so without the fill the transparent surround turns white. */
      var scale = Math.min(1, SHOT_W / box.w);
      var out = document.createElement('canvas');
      out.width = Math.max(1, Math.round(box.w * scale));
      out.height = Math.max(1, Math.round(box.h * scale));

      var octx = out.getContext('2d');
      octx.fillStyle = '#0a0a0a';
      octx.fillRect(0, 0, out.width, out.height);
      octx.drawImage(gl, box.x, box.y, box.w, box.h, 0, 0, out.width, out.height);

      return out.toDataURL('image/jpeg', SHOT_QUALITY);
    } catch (e) {
      return null; /* a missing picture must never block the save */
    }
  }

  /* ---- reading the build ------------------------------------------------- */

  function currentCode() {
    try {
      if (!window.__pmShare || !window.__pmShare.url) return null;
      var url = window.__pmShare.url();
      if (!url) return null;
      var at = url.indexOf('?build=');
      return at > -1 ? url.slice(at + 7) : null;
    } catch (e) {
      return null;
    }
  }

  function currentConfig() {
    try {
      return (window.__pmShare && window.__pmShare.read) ? window.__pmShare.read() : null;
    } catch (e) {
      return null;
    }
  }

  function nameFor(cfg) {
    if (!cfg) return 'Custom build';
    var body = (cfg.v && cfg.v[0]) || '';
    var extras = [];
    var p = cfg.p || {};
    if (p.Seat && p.Seat !== 'Surron') extras.push(p.Seat);
    if (p.Controller && p.Controller !== 'Surron') extras.push(p.Controller);
    if (p.Battery && p.Battery !== 'Surron') extras.push(p.Battery);
    if (p.Motor && p.Motor !== 'Surron') extras.push(p.Motor);

    var base = body ? body + ' Surron' : 'Custom build';
    if (!extras.length) return base;
    if (extras.length === 1) return base + ' / ' + extras[0];
    return base + ' / ' + extras.length + ' upgrades';
  }

  function list() {
    return read();
  }

  function add() {
    var code = currentCode();
    if (!code) return null;

    var all = read();
    var shot = snapshot();

    for (var i = 0; i < all.length; i++) {
      if (all[i].code === code) {
        all[i].at = Date.now();
        if (shot) all[i].shot = shot;
        write(all);
        return all[i];
      }
    }

    var entry = {
      id: 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6),
      code: code,
      name: nameFor(currentConfig()),
      path: location.pathname,
      at: Date.now()
    };
    if (shot) entry.shot = shot;

    all.unshift(entry);
    write(all);
    return entry;
  }

  function remove(id) {
    var all = read();
    var out = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].id !== id) out.push(all[i]);
    }
    write(out);
    return out;
  }

  function clear() {
    try { window.localStorage.removeItem(KEY); } catch (e) {}
  }

  /* ---- the Save button --------------------------------------------------- */

  function css() {
    if (document.getElementById('pm-garage-css')) return;
    var s = document.createElement('style');
    s.id = 'pm-garage-css';
    s.textContent =
      '.pm-garage-save{width:100%;margin-top:.6rem;padding:.8rem 1rem;' +
      'border:1px solid rgba(255,255,255,.22);border-radius:12px;background:transparent;' +
      'color:rgba(255,255,255,.78);font-family:inherit;font-size:.72rem;font-weight:700;' +
      'letter-spacing:.08em;text-transform:uppercase;cursor:pointer;touch-action:manipulation;' +
      'transition:background .14s ease,border-color .14s ease,color .14s ease;}' +
      '.pm-garage-save:hover{background:rgba(255,255,255,.07);border-color:rgba(255,255,255,.45);color:#fff;}' +
      '.pm-garage-save.is-done{background:#fff;border-color:#fff;color:#0a0a0a;}' +
      '.pm .pm-garage-save,#pm-3d .pm-garage-save{border-radius:12px !important;}' +
      '@media (max-width:900px){.pm-garage-save{min-height:48px;}}';
    (document.head || document.documentElement).appendChild(s);
  }

  function mountButton() {
    if (document.querySelector('.pm-garage-save')) return true;

    var addcart = document.querySelector('#pm-3d .pm-addcart');
    if (!addcart) return false;

    css();

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pm-garage-save';
    btn.textContent = 'Save to my garage';

    btn.addEventListener('click', function () {
      var entry = add();
      if (!entry) {
        btn.textContent = 'Could not save';
        window.setTimeout(function () { btn.textContent = 'Save to my garage'; }, 1800);
        return;
      }
      btn.textContent = 'Parked in your garage';
      btn.classList.add('is-done');
      window.setTimeout(function () {
        btn.textContent = 'Save to my garage';
        btn.classList.remove('is-done');
      }, 2200);
    });

    /* Anchored to Add to cart, not to builder-share's button, so the two
       scripts never depend on each other's timing. */
    addcart.parentNode.insertBefore(btn, addcart.nextSibling);
    return true;
  }

  function waitForBuilder() {
    var tries = 0;
    var poll = window.setInterval(function () {
      tries++;
      if (mountButton() || tries > 150) window.clearInterval(poll);
    }, 200);
  }

  if (document.getElementById('pm-3d')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', waitForBuilder);
    } else {
      waitForBuilder();
    }
  }

  window.__pmGarage = {
    list: list,
    add: add,
    remove: remove,
    clear: clear,
    nameFor: nameFor,
    snapshot: snapshot
  };
})();